<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span style="margin-bottom: 5px;">Készletmozgatások</span>
      <el-button
        v-can="'stocktransformation.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/processes/stock-movements/add')"
      >
        Új készletmozgatás
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="stockMovement/fetchAllWithPagination"
      />
    </div>
    <stock-movement-list />
    <template v-if="$route.meta.showViewStockMovementDialog">
      <stock-movement-dialog
        type="view"
        :stock-movement-id="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showAddStockMovementDialog">
      <stock-movement-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateStockMovementDialog">
      <stock-movement-dialog
        type="update"
        :stock-movement-id="$route.params.id"
      />
    </template>
  </el-card>
</template>

<script>
  import StockMovementList from '../../components/processes/stockMovements/List';
  import StockMovementDialog from '../../components/processes/stockMovements/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      StockMovementDialog,
      StockMovementList,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        await this.$store.dispatch('storage/fetchAll');
        const storages = this.$store.getters['storage/storages'];
        await this.$store.dispatch('user/fetchAll');
        const users = this.$store.getters['user/users'];

        this.filterConfig = [
          {
            type: 'select',
            options: storages,
            name: 'source_storage_id',
            label: 'Átadó raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
            defaultSearch: true
          },
          {
            type: 'select',
            options: storages,
            name: 'target_storage_id',
            label: 'Átvevő raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'user_id',
            label: 'Létrehozó',
            labelCallback: user => user && user.full_name || '',
            valueKey: 'id',
          },
          {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Teljesítve',
              status: 'done'
            },
            {
              label: 'Folyamatban',
              status: 'in-progress'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        ];
      },
    },
  };
</script>

